import {useContext} from 'react';

import {CheckoutIssuingContext} from './CheckoutIssuingContext';

export function useCheckoutIssuing() {
  const context = useContext(CheckoutIssuingContext);
  if (!context) {
    throw new Error('useCheckoutIssuing must be used within CheckoutIssuingProvider');
  }
  return context;
}
